import { ComponentType, PropsWithChildren, SVGProps } from 'react'
import { Heading } from '@repo/ui'

export interface EmptyStateProps {
  icon?: ComponentType<SVGProps<SVGSVGElement>>
  title?: string
  text: string
  'data-testid': string
}

export default function EmptyState({
  icon: IconComponent,
  title,
  text,
  'data-testid': testId,
  children
}: PropsWithChildren<EmptyStateProps>) {
  return (
    <div
      className="text-center border border-dashed rounded-lg border-cool-gray-500 p-3 dark:bg-cool-gray-800 dark:border-cool-gray-200"
      data-testid={testId}
    >
      {IconComponent && (
        <IconComponent
          className="shrink-0"
          width={32}
          height={32}
          data-testid={`${testId}-icon`}
        />
      )}
      {title && (
        <Heading
          tag="h3"
          className="mt-1 flex-grow"
          data-testid={`${testId}-title`}
        >
          {title}
        </Heading>
      )}
      <p
        className="mt-1 text-cool-gray-700 dark:text-cool-gray-200"
        data-testid={`${testId}-text`}
      >
        {text}
      </p>
      {children && <div className="mt-2">{children}</div>}
    </div>
  )
}
